import { FC } from 'react';
import { withStyles } from '../../../utils';
import styles from './RadioButtonIndicator.module.scss';

const cn = withStyles(styles);

type RadioButtonIndicatorProps = {
  checked: boolean;
};

const RadioButtonIndicator: FC<RadioButtonIndicatorProps> = ({ checked }) => {
  return <div className={cn('radioIndicatorContainer', checked && 'checked')} />;
};

export default RadioButtonIndicator;
